import { Component } from '@angular/core';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';

@Component({
  standalone: false,
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  selector: 'not-found'
})
export class NotFoundComponent {
  constructor(private appStateSrv: AppStateProvider) {
    this.appStateSrv.setLoginStatus(true)
  }
}
